import { PREDEFINED_TENANTS } from 'swag-common/constants/main-swag.constants';
export function checkIsSwagOrResellerOrder(order, includeCustomInk = true) {
  const tenants = [PREDEFINED_TENANTS.SENDOSO, PREDEFINED_TENANTS.POSTAL];
  if (includeCustomInk) {
    tenants.push(PREDEFINED_TENANTS.CUSTOM_INK);
  }
  return !tenants.includes(order.tenant);
}